import React from "react";
import { PageHero, PageBody } from "./_shared";
import { useRoe } from "./RoeLayout";
import BodyMembersTable from "@/components/BodyMembersTable";

export default function GoverningBodyPage() {
  const data = useRoe();
  const list = data.governing_body || [];
  return (
    <div data-testid="roe-gb-page-wrap">
      <PageHero eyebrow="About" title="Governing Body Members" />
      <PageBody>
        <BodyMembersTable members={list} theme="navy" testidPrefix="roe-gb-page" />
      </PageBody>
    </div>
  );
}
